/*
命名规范
1. 小写驼峰
2. 特殊情况可特殊处理（如 侧边栏，导航栏等直接关联key的词可以采用大写驼峰）
standard  通用标准字段
login  登录
register 注册
resetPassword 忘记密码（找回密码/密码重置)
modifyPassword 修改密码 (公共组件)
cookies cookies政策（公共组件)
slideCircus 滑块拼图验证码（公共组件)
message 消息提醒
verify 表单校验提示
placeholder 表单项描述输入字段预期值的提示信息
tagsView 图钉功能相关
exit 退出登录相关
notFind 404
settings 整体相关
role 权限相关
button 按钮
accountInfo 账号信息
baseInfo 基本信息
emailLink 邮箱链接
accountSecurity 账户安全
*/

export default {
  'standard': {
    '用户不存在': 'Akaun ini tidak terdaftar. Sila pergi mendaftar sebelum log masuk	',
    '授权校验失败，请刷新页面并重试。': 'Authorization verification failed. Please refresh the page and try again.',
    'onlineService': 'Online service',
    'eParcel': 'E-Parcel/ E-Parcel+',
    'overseasFulfilment': 'Pemenuhan Luar Negara',
    'warehouse': 'Gudang',
    'standardExpress': 'Ekspres Standard',
    'economyExpress': 'Ekspres Ekonomi',
    'heavyFreight': 'Pengangkutan Berat',
    'pleaseAgreePolicy': 'Sila baca dan setuju menerima Dasar Privasi',
    'pleaseAgreeToScan': 'Sila tandakan dasar privasi di sebelah kanan dahulu',
    '验证码接收方式': 'Cara dapatkan kod pengesahan',
    'cancelTips': 'Akaun anda tidak terikat dengan nombor telefon atau e-mel. Sila ikat dahulu.',
    'confirmCancel': 'sahkan',
    'verificationCodeError': 'Ralat kod pengesahan, sila dapatkan kod pengesahan sekali lagi.',
    'clickGoDirectly': '(Klik untuk pergi terus ke)',
    'repeatTips': 'Terdapat masalah pendua dengan akaun anda. Sila pergi ke<span class="mode">pilih kaedah log masuk</span> dan log masuk. Ia akan melompat secara automatik selepas {count}s.',
    'repeatTips1': 'Terdapat masalah pendua dengan nombor telefon mudah alih anda. Sila log masuk selepas<span class="mode">memilih kod kawasan</span> dan lompat secara automatik selepas {count}s.',
    'goOldLogin': 'Log masuk versi lama',
    'goNewLogin': 'Log masuk versi baharu',
    'siteTips': 'Untuk pengalaman sistem yang lebih baik, anda boleh memilih untuk bertukar ke negara atau wilayah lain',
    'siteGo': 'Teruskan',
    'loginLoading': 'Akaun anda akan log masuk ke sistem baharu secara automatik, sila tunggu sebentar',
    'sfExpress': 'Laman web rasmi, semua hak terpelihara. Guangdong ICP Nombor Sandaran 08034243',
    'sgSfExpress': 'Laman web rasmi, semua hak terpelihara. Guangdong ICP Nombor Sandaran 08034243',
    'kex': 'KEX',
    'iuopOsPatent': 'Copyright© ABX EXPRESS (M) SDN BHD. All Rights Reserved.	',
    'unite': 'Perkhidmatan Pengesahan Pusat Antarabangsa',
    'jumpError': 'Alamat lompat adalah haram',
    'tips': 'Petua',
    'tips1': 'Petua',
    'confirm': 'Sahkan',
    'agreeWith': 'I have read and agree to the ',
    'agreeAndContinue': 'Saya telah baca dan setuju dengan Dasar Privasi',
    'agreeService': 'Saya telah baca dan setuju dengan Syarat Perkhidmatan',
    'agreeUserAgreement': 'Saya telah baca dan setuju dengan Perjanjian Pengguna',
    'define': 'Sahkan',
    'cancel': 'Batal',
    'yes': 'Ya',
    'no': 'Tidak',
    'sendAgain': 'Hantar sekali lagi',
    'second': 'saat',
    'iknow': 'saya tahu',
    'country': 'Negara/daerah',
    'tel': ' no telefon',
    'email': 'E-mel',
    'telNumber': ' No. telefon',
    'verifyCode': 'Masukkan kod',
    'sendVerificationCode': 'Dapatkan kod',
    'next': 'Seterusnya',
    'prev': 'Sebelumnya',
    'finished': 'Selesai',
    'back': 'Balik',
    'backLogin': 'Kembali ke log masuk',
    'home': 'Laman web rasmi',
    'inquiry': 'Pertanyaan',
    'add': 'Tambah',
    'edit': 'Edit',
    'del': 'Padam',
    'batchDel': 'Padam kelompok',
    'operating': 'Beroperasi',
    'clearInfo': 'Padam maklumat',
    'excelUpload': 'Muat naik Excel',
    'serialNumber': 'nombor siri',
    'save': 'Simpan',
    'leastOne': 'Tandakan data yang hendak dipadamkan',
    'uploadFile': 'Memuat naik fail',
    'downloadExcel': 'Muat turun templat EXCEL',
    'pleaseInput': 'Masukkan ',
    'pleaseSelect': 'Sila pilih',
    'isDel': 'Padamkan data yang dipilih?',
    'agree': 'Setuju',
    'disagree': 'Tidak Setuju',
    'uploadTotal': 'Jumlah muat naik',
    'uploadSuccess': 'Muat naik berjaya',
    'uploadFail': 'Muat naik gagal',
    'checkAll': 'Pilih semua',
    'cancelContent': 'Pembatalan akaun ini diserahkan pada [{cancelTime}], akaun akan diaktifkan jika log masuk dalam 15 hari. Teruskan log masuk atau tidak?',
    'ok': 'OK',
    'autoTip': 'Pengesahan sedang dijalankan, sila tunggu...',
    'feedback': 'Cadangan Fungsi',
    'scanCode': 'Imbas kod QR',
    'useWxScan': 'Mengimbas kod QR WeChat',
    'useWhatsAppScan': 'Mengimbas kod QR WhatsApp',
    'otherLoginWays': 'Cara lain log masuk',
    'scanSuccessfully': 'Imbas kod berjaya',
    'confirmOnPhone': 'Sila sahkan telefon bimbit anda',
    'refreshQR': 'Klik untuk memuat semula',
    'consult': 'Perundingan',
    'please_select_correct_phone': 'Sila pilih kod kawasan telefon yang betul',
    '国际标快': 'Standard Express',
    '国际特惠': 'Economy Express',
    '顺丰集运': 'SFBUY',
    '国际电商专递': 'E-Commerce Express',
    '国际小包': 'E-Parcel',
    '海外仓': 'Overseas Fulfilment/Warehouse',
    '顺丰国际产品导航': 'Product Navigation'
  },
  'channel': {
    'gls': 'Sistem Liga Global',
    'gls_tooltip': 'Sila isikan akaun log masuk dalam e-mel, subjek e-mel [GLS Lupa kata laluan], dan hantar e-mel ke [wuzipeng@sf-express.com]',
  },
  'login': {
    'selectLoginType': 'Pilih jenis log masuk',
    'personal': 'Log Masuk Peribadi',
    'enterprise': 'Log masuk syarikat',
    'tel': ' no telefon',
    'password': 'Kata laluan',
    'verificationCodeLogin': 'Daftar masuk',
    'verificationCode': 'Masukkan kod',
    'obtainVerificationCode': 'Dapatkan kod',
    'passwordLogin': 'Logmasuk kata laluan',
    'rememberPSD': 'Ingat saya',
    'rememberTips': 'Tidak disyorkan untuk peranti awam',
    'forgetPSD': 'Lupa kata laluan',
    'loginAgree': 'Saya telah baca dan setuju dengan',
    'agreeTips': 'Dasar Privasi',
    // 'epesAcceptableUse': 'SF Korea ERP 이용 약관',
    'userAgreement': 'Perjanjian Pengguna',
    'login': 'Log masuk',
    'username': 'Nama pengguna',
    'email': 'E-mel',
    'phoneLogin': 'Log masuk dengan telefon no.',
    'usernameLogin': 'Log masuk dengan nama pengguna',
    'emailLogin': 'Log masuk dengan e-mel',
    'usernameOrEmailLogin': 'Log masuk dengan nama pengguna atau e-mel',
    'registerNow': 'Daftar sekarang',
    'pleaseInput': '',
    'and': ' dan ',
    'sfbuy_privacy': '《SFBuy Service Agreement(Chinese Mainland)》、《SFBuy Service Agreement(International/HK, MO and TW of China)》',
    'sfbuy_title': 'SFBuy',
    'aboutUs': 'Mengenai kami',
    'serviceGuide': 'Panduan perkhidmatan',
    'helpCenter': 'Pusat bantuan',
    'serviceAndPrice': 'Perkhidmatan dan Harga',
    'onlineCSR': 'Perkhidmatan pelanggan dalam talian',
    'copyright': 'Hak Cipta ©2023 KEX',
  },
  'register': {
    'personal': 'Pendaftaran pengguna peribadi',
    'enterprise': 'Pendaftaran pengguna syarikat',
    'tel': 'Nombor telefon',
    'telVerificationCode': 'Kod pengesahan melalui SMS',
    'emailVerificationCode': 'Masukkan kod',
    'sendVerificationCode': 'Dapatkan kod',
    'password': 'Kata laluan',
    'passwordAgain': 'Mengesahkan kata laluan',
    'agree': 'Setuju',
    'termsOfService': 'Syarat Perkhidmatan',
    'SFBuyService': 'Perjanjian Perkhidmatan SFBuy',
    'privacyPolicy': 'Dasar Privasi',
    'haveUserName': 'Sudah mempunyai akaun?',
    'loginNow': 'Log masuk sekarang',
    'registerNow': 'Daftar sekarang',
    'toEmail': 'Daftar e-mel',
    'toTel': 'Daftar telefon',
    'invitationCode': 'Kod Jemputan',
    'timeCount': '（{count}s yang tinggal, sila baca hingga habis）',
    'readBottom': '（Sila baca sampai habis）',
    'isFinshRead': 'Sila baca dan setuju dengan terma dan syarat',
    sfbuy_policy1: '《SFBuy Service Agreement(Chinese Mainland)	》',
    sfbuy_policy2: '《SFBuy Service Agreement(International/HK, MO and TW of China)	》'
  },
  'resetPassword': {
    'resetTel': 'Set semula melalui telefon',
    'resetEmail': 'Set semula melalui e-mel',
    'tel': 'Nombor telefon',
    'telVerificationCode': 'Kod pengesahan melalui SMS',
    'emailVerificationCode': 'Masukkan kod',
    'sendVerificationCode': 'Dapatkan kod',
    'email': 'E-mel',
    'newPassword': 'kata laluan baharu',
    'confirmNewPassword': 'Sahkan kata laluan baharu',
    'resetPassword': 'Menetapkan semula kata laluan',
    'back': 'Menetapkan semula kata laluan',
    'login': 'Kembali',
    'register': 'Daftar',
  },
  'modifyPassword': {
    'changePassword': 'Tukar kata laluan',
    'old': 'Kata laluan lama',
    'new': 'Kata laluan baharu',
    'confirm': 'sahkan'
  },
  'cookies': {
    // v1.4.sp4开始
    'tip1': 'Laman web kami menggunakan kuki untuk mengoptimumkan pengalaman dan analitik pengguna. Kami mungkin berkongsi maklumat anda dengan rakan kongsi analitis kami. kami',
    'tip2': 'polisi kuki',
    'tip3': 'mempunyai maklumat lanjut. Tukar tetapan anda',
    'tip4': 'di sini',
    'tip5': 'Dengan mengklik TERIMA anda bersetuju dengan penggunaan kuki kami mengikut keutamaan anda.',
    'disAgree': 'Tidak bersetuju',
    'cookieSet': 'Tetapan Kuki',
    'preference': 'Pilihan',
    'optimisation': 'Pengoptimuman',
    'analytics': 'Analitis',
    'neddCheck': 'Anda mesti bersetuju dengan pilihan terlebih dahulu',
    'cookie': 'polisi kuki',
    'agree': 'setuju',
    'preferenceCenter': 'Pusat pilihan'
  },
  'slideCircus': {
    'title': 'Sila lengkapkan pengesahan teka-teki di bawah',
    'change': 'Ubah',
    'right': 'Sila luncur ke kanan',
    'pass': 'Pengesahan lulus',
    'verifyText': 'Sila klik butang untuk pengesahan',
    'verifying': 'Pengesahan teka-teki…',
    'loading': 'Memuatkan foto'
  },
  'message': {
    'slideError': 'Permintaan perkhidmatan peluncur gagal',
    'selectTerms': 'Sila semak dan tandakan maklumat syarat',
    'verifyPass': 'Sila klik untuk pengesahan',
    'registerSuccess': 'Berjaya didaftarkan',
    'sendTips0': 'Berjaya dihantar',
    'resetPasswordTips0': 'Berjaya menetapkan semula kata laluan',
    'loginTips0': 'Berjaya log masuk',
    'loginTips1': 'Log masuk berjaya, akaun telah diaktifkan',
    'modifiedTips0': 'Pengubahsuaian selesai',
    'switchLanguage': 'Bahasa berjaya ditukar',
    'switchSite': 'Negara berjaya ditukar',
    'changeTel': 'Tahniah, nombor telefon bimbit anda telah berjaya diubah suai, sila log masuk semula!',
    'ChangeEmail': 'Tahniah, alamat e-mel anda telah berjaya diubah suai, sila log masuk semula!',
    'cancelSuccess': 'Tahniah, akaun anda telah berjaya dibatalkan!',
    'imgType': 'Sila pilih foto sekali lagi, hanya format JPG dan PNG disokong untuk muat naik!',
    'imgSize': 'Sila pilih foto sekali lagi, saiz foto tidak boleh melebihi 3MB!',
    'submitSuccess': 'Dihantar dengan berjaya',
    'setSuccess': 'Persediaan yang berjaya',
    'delSuccess': 'Berjaya dipadamkan',
    'addSuccess': 'Berjaya ditambahkan',
    'fileType': 'Pilih fail sekali lagi, hanya format xls dan xlsx yang disokong!',
    'fileSize': 'Pilih fail sekali lagi, saiz fail tidak boleh melebihi 15MB!',
    'delError': 'Gagal padam, cuba lagi kemudian',
    'uploadFile': 'Muat naik fail',
    'uploadFileSuccess': 'Muat naik berjaya',
    'selectedOne': 'Sekurang-kurangnya satu jenis maklumat pelepasan atau tarikh lahir',
    'imgTips1': 'Muat naik foto dalam format {imgType}.',
    'imgTips2': 'Satu imej tidak boleh melebihi 3MB',
    'imgTips3': 'Satu imej tidak boleh melebihi 10MB',
    'imgTips4': 'Pratonton fail PDF tidak disokong',
    'checkProduct': 'Sila pilih produk',
    'clauseAgree': 'Sila bersetuju dengan Terma dan Syarat E-waybill',
    'estimatedCost': 'Sila masukkan anggaran kos dalam borang perkhidmatan tambahan',
    'cardCode': 'Sila masukkan nombor kad COD dalam borang perkhidmatan tambahan',
    'threeTips': 'Maklumat artikel tidak lengkap, sila semak semula',
    'fourTips': 'Maklumat penempatan pesanan tidak lengkap, semak semula',
    'noNeedUpload': 'Tidak perlu memuat naik dokumen',
    'phoneOrFixAtLeastOne': 'Sila isikan sekurang-kurangnya satu nombor telefon bimbit dan nombor talian tetap',
    'customerOrderNo': 'Sila masukkan nombor pesanan pelanggan',
    'mas_003038': 'Ralat berlaku dengan nombor akaun anda, sila muat semula halaman dan cuba buat pesanan penghantaran antarabangsa.',
    'mas_003038_HTM': 'Ralat telah berlaku dengan log masuk anda (nombor telefon mudah alih) , sila muat semula halaman dan cuba buat pesanan penghantaran antarabangsa.',
    'mas_003035': 'Jika anda telah mendaftar, sila log masuk IUOP terus untuk membuat pesanan penghantaran antarabangsa.',
    'mas_auth_failed': 'Pengesahan gagal'
  },
  'verify': {
    'selectAreaCode': 'Sila pilih kod negara atau daerah',
    'telTips': 'Masukkan nombor telefon',
    'telError': 'Sila masukkan No telefon bimbit yang betul.',
    'companyNameTrue': 'Sila masukkan nama syarikat yang betul',
    'fixMobileCode': 'Sila pilih kod daerah telefon tetap',
    'fixMobileNumber': 'Sila masukkan No telefon tetap.',
    'fixMobileNumberReg': 'Sila masukkan No telefon tetap yang betul.',
    'mobileVerificationCode': 'Masukkan kod',
    'emailAddress': 'Masukkan e-mel',
    'emailTips': 'Masukkan e-mel',
    'emailVerificationCode': 'Masukkan kod',
    'password': 'kata laluan',
    'passwordError': 'Kata laluan ialah 8-20 digit, dan hanya menyokong tiga atau lebih kombinasi huruf besar dan kecil, nombor dan simbol',
    'passwordAgain': 'Mengesahkan kata laluan',
    'passwordNotSame': 'Kata laluan yang dimasukkan tidak konsisten. Sila masukkan semula',
    'usernameTips': 'Sila masukkan nama pengguna',
    'usernameEmailTips': 'Sila masukkan nama pengguna/e-mel',
    'telEmailTips': 'Masukkan no telefon/e-mel',
    'fixTelEmailTips': 'Sila masukkan no telefon/e-mel yang betul',
    'selectTerms': 'Sila semak dan tandakan maklumat syarat',
    'accountName': 'Ia hanya menyokong 6-20 karakter bermula dengan huruf dan hanya boleh mengandungi huruf, nombor dan garis bawah',
    'verifyType': 'Sila pilih mod pengesahan',
    'verifyCode': 'Masukkan kod',
    'lastNameRequired': 'Nama akhir tidak boleh kosong',
    'firstNameRequired': 'Nama pertama tidak boleh kosong',
    'genderRequired': 'Jantina tidak boleh kosong',
    'birthdayRequired': 'Hari lahir tidak boleh kosong',
    'certTypeRequired': 'Jenis sijil tidak boleh kosong',
    'certNoRequired': 'No. sijil tidak boleh kosong',
    'certExpireDateRequired': 'Kesahan sijil tidak boleh kosong',
    'notSupTips': 'Nombor dan karakter khas lain tidak disokong',
    'certImage': 'Sila muat naik gambar sijil sebelum menghantar',
    'commodityName': 'Sila masukkan nama konsainan',
    'quantity': 'Sila masukkan kuantiti',
    'unit': 'Sila pilih unit',
    'unitPrice': 'Sila masukkan harga seunit',
    'placeOfOrigin': 'Sila pilih negara asal',
    'over0': 'Sila masukkan nombor yang lebih besar daripada 0',
    'decimal3': 'Hanya 3 digit selepas titik perpuluhan disokong',
    'decimal6': 'Hanya 6 digit selepas titik perpuluhan disokong',
    'decimal10': 'Hanya 10 digit selepas titik perpuluhan disokong',
    'productRecordNo': 'Masukkan Nombor Rekod Pemeriksaan Kebangsaan yang betul.',
    'hsCode': 'Masukkan kod HS yang betul',
    'productCustomsNo': 'Masukkan Nombor EORI yang betul',
    'contact': 'Sila masukkan nama anda',
    'companyName': 'Sila masukkan nama syarikat',
    'country': 'Sila pilih negara/daerah',
    'regionFirst': 'Sila pilih wilayah atau bandar',
    'roadName': 'Sila masukkan nama jalan',
    'buildingNumber': 'Sila masukkan nombor bangunan',
    'addressDetail': 'Sila masukkan alamat terperinci',
    'addressDetailTrue': 'Sila masukkan butiran alamat yang betul',
    'postalCode': 'Sila masukkan poskod',
    'phoneNumber': 'Masukkan nombor telefon',
    'numberDecimal': 'Sila masukkan nombor',
    'bangmecho': 'Input daerah/jalan/No.',
    'shippingType': 'Sila pilih jenis penghantaran',
    'clearanceInfo': 'Sila pilih jenis dokumen',
    'idNumber': 'Masukkan nombor sijil.',
    'idNumberIsTrue': 'Masukkan nombor sijil yang betul.',
    'contactCn': 'Sila masukkan nama Cina yang betul',
    'receiveType': 'Pilih jenis sijil',
    'imgNumber': 'Muat naik sekurang-kurangnya {number} imej',
    'papersTime': 'Sila pilih tempoh sah sijil',
    'declaredCurrency': 'Sila pilih mata wang',
    'requred': 'Medan ini diperlukan',
    'parcelTotalWeight': 'Sila masukkan jumlah berat',
    'contentMaxLength18': '18 integer dan 6 perpuluhan disokong pada maksimum',
    'contentIntOrFloatMaxLength': '12 integer dan 10 perpuluhan disokong pada maksimum',
    'atLeastSelectTip': 'Sila pilih sekurang-kurangnya satu rekod',
    'invitationCode': 'Sila masukkan kod jemputan yang betul',
    'characterLength': 'Tidak lebih daripada {length} karakter ',
    'pickUpTime': 'Pilih masa pengambilan ke pintu yang ditetapkan',
    'onlyNumberAndLetter': 'Hanya gabungan nombor dan huruf yang disokong',
    'serviceFee': '12 integer dan 2 perpuluhan disokong pada maksimum',
    'methoedCode': 'Hanya 20 nombor yang disokong secara maksimum',
    'contentInt14OrFloat2MaxLength': '14 integer dan 2 perpuluhan disokong pada maksimum',
    'contentInt10OrFloat6MaxLength': '10 integer dan 6 perpuluhan disokong pada maksimum',
    'contentInt18OrFloat6MaxLength': '18 integer dan 6 perpuluhan disokong pada maksimum'
  },
  'placeholder': {
    'countryCode': 'Sila pilih kod negara atau daerah',
    'telCode': 'Kod daerah',
    'phoneCode': 'Sila masukkan no. telefon',
    'mobileVerificationCode': 'Masukkan kod',
    'verificationCode': 'Masukkan kod',
    'emailAddress': 'Masukkan e-mel',
    'emailVerificationCode': 'Masukkan kod',
    'password': 'kata laluan',
    'checkPassword': 'Mengesahkan kata laluan',
    'enter': 'Sila masukkan',
    'username': 'Nama Pengguna',
    'cardType': 'Sila pilih jenis sijil',
    'uploadCard': 'Harus konsisten dengan maklumat sijil',
    'uploadCardId': 'Sila masukkan nombor sijil yang sah.',
    'passwordError': 'Kata laluan ialah 8-20 digit, dan hanya menyokong tiga atau lebih kombinasi huruf besar dan kecil, nombor dan simbol',
    'passwordAgain': 'Mengesahkan kata laluan',
    'verifyType': 'Sila pilih mod pengesahan',
    'newEmail': 'Sila pilih e-mel anda yang kerap digunakan',
    'addressBook': 'Masukkan nama/nama syarikat untuk pertanyaan',
    'goodsWarehouse': 'Masukkan nama konsainan/kod HS untuk pertanyaan',
    'clearanceWaybill': 'Masukkan nombor waybill 12 digit atau nombor waybill 15 digit yang bermula dengan SF',
    'parcelTotalLength': 'Sila masukkan panjang',
    'parcelTotalWidth': 'Sila masukkan lebar',
    'parcelTotalHeight': 'Sila masukkan tinggi',
    'senderReason': 'Pilih sebab penghantaran',
    'tradeCondition': 'Pilih syarat perdagangan',
    'senderReasonContent': 'Sila isikan sebab penghantaran bukan komersial',
    'businessRemark': 'Sila isikan kenyataan invois komersial',
    'pickupAppointTime': 'Pilih tarikh dan masa (masa pengambilan adalah dalam masa 3 jam dari janji temu anda)',
    'remarkText': 'Teks boleh dimasukkan secara manual',
    'payMethod': 'Sila pilih kaedah pembayaran',
    'payMonthCard': 'Sila masukkan akaun kredit',
    'taxPayMethod': 'Sila pilih kaedah pembayaran cukai',
    'taxPayMonthCard': 'Sila masukkan nombor akaun penyelesaian cukai',
    'serviceFee': '12 integer dan 2 perpuluhan disokong pada maksimum',
    'feeCard': 'Sila masukkan nombor kad COD',
    'invitationCode': 'Sila masukkan kod jemputan',
    'willBay': 'Sila masukkan nombor waybill',
    'senderCountry': 'Sila pilih tempat asal',
    'receiverCountry': 'Sila pilih destinasi',
    'receiverContact': 'Sila masukkan nama penerima',
    'orderStatus': 'Sila pilih status pesanan',
    'startTime': 'tarikh mula',
    'to': 'ke',
    'endTime': 'tarikh tamat',
    'timeZoneCode': 'Sila pilih zon waktu'
  },
  'tagsView': {
    'refresh': 'Muat semula',
    'close': 'tutup',
    'closeOthers': 'Tutup yang lain',
    'closeAll': 'Tutup semua'
  },
  'exit': {
    'title': 'log keluar',
    'message': 'sahkan keluar?',
    'success': 'Berjaya log keluar',
    'cancel': 'Batal log keluar',
    'close': 'Tutup'
  },
  'notFind': {
    'oops': '404',
    'info': 'Maaf, halaman yang anda lawati tidak wujud',
    'backHome': 'kembali ke laman utama',
  },
  'settings': {
    'title': 'KEX User Authorization Center',
  },
  'role': {
    'admin': 'pentadbir',
    'user': 'pengguna umum',
  },
  'route': {
    'Login': 'Log masuk',
    '顺丰国际产品导航': 'Product Navigation',
    'Register': 'Daftar',
    'ResetPassword': 'Menetapkan semula kata laluan',
    'UserCenter': 'Profil',
    'MyInfomation': 'maklumat saya',
    'AccountInfomation': 'Maklumat Akaun',
    'BaseInfomation': 'Maklumat asas',
    'AccountSecurity': 'Keselamatan akaun',
    'ProtocolManage': 'Pengurusan tandatangan',
    'BindingEmail': 'Ikat dengan e-mel',
    'BindingPhone': 'Ikat dengan telefon',
    'CancelAccount': 'Batalkan akaun',
    'AccountSetting': 'Tetapan Akaun',
    'ChangeEmail': 'Tahniah. Nombor telefon anda berjaya ditukar. Sila log masuk semula!',
    'ChangePassword': 'tukar kata laluan',
    'ChangePhone': 'Tukar nombor telefon bimbit',
    'Name': 'Tetapkan Nama Pengguna',
    'ToMail': 'penghantaran',
    'MailProduct': 'Produk penghantaran',
    'AddressBook': 'Masukkan nama/nama syarikat untuk pertanyaan',
    'GoodsWarehouse': 'Masukkan nama konsainan/kod HS untuk pertanyaan',
    'Order': 'Pengurusan pesanan',
    'OrderIndex': 'Senarai Pesanan',
    'OrderAdd': 'Pesanan penghantaran tunggal',
    'Clearance': 'Maklumat pelepasan kastam',
    'UploadPhotoid': 'Muat naik sijil',
    'EditOrder': 'Pengeditan pesanan',
    'permission': 'pengurusan pihak berkuasa',
    'permission_system': 'Pengurusan Sistem',
    'permission_role': 'pengurusan peranan',
    'permission_resource': 'Kebenaran sumber',
    'permission_user': 'Pengurusan pengguna'
  },
  'button': {
    'sumbit': 'Hantar',
  },
  'accountInfo': {
    'username': 'Nama Pengguna',
    'firstname': 'Nama: ',
    'lastname': 'Nama akhir: ',
    'sex': 'Jantina: ',
    'man': 'Lelaki',
    'woman': 'Perempuan',
    'telNumber': 'Nombor telefon bimbit',
    'telNumberNot': 'Akaun anda belum terikat dengan nombor telefon bimbit.',
    'email': 'e-mel',
    'emailNot': 'Akaun anda tidak terikat dengan e-mel',
    'binding': 'Ikat segera>',
    'changeTel': 'Tahniah. Nombor telefon bimbit anda berjaya ditukar. Sila log masuk semula!',
    'changeEmail': 'tahniah. E-mel anda berjaya ditukar. Sila log masuk semula!',
    'validated': 'Disahkan',
    'autoGeneration': 'Dijana secara automatik',
    'usernameTips': 'Sila masukkan nama pengguna',
    'birthday': 'Hari Lahir：',
    'birthday1': 'Hari Lahir',
    'autoCreate': 'Dijana secara automatik'
  },
  'baseInfo': {
    'cardType': 'Sila pilih jenis sijil：',
    'firstname': 'Nama: ',
    'lastname': 'Nama akhir: ',
    'cardId': 'Nombor sijil: ',
    'cardTime': 'Kesahan sijil: ',
    'cardImg': 'Gambar sijil: ',
    'cardLangTime': 'Sah kekal',
    'uploadImg': 'Muatnaik gambar',
    'titleTips': 'Petua: Nama sebenar diperlukan oleh negara untuk menghantar penghantaran untuk pelepasan kastam, maklumat sijil akan dicap dengan meterai eksklusif pelepasan kastam. KEX akan menjamin keselamatan maklumat anda.',
    'dialogTitle': 'Contoh standard',
    'dialogTips': 'Gambar sijil hendaklah lengkap dan teks hendaklah jelas tanpa pantulan cahaya dan perisai. Jika terlalu gelap, pengesahan akan gagal!',
    'cardUp': 'Bahagian hadapan kad sijil',
    'cardDown': 'Bahagian belakang kad sijil',
  },
  'emailLink': {
    'tips': 'Petua',
    'setPassword': 'tetapkan kata laluan',
    'success': 'Berjaya keluar!',
  },
  'accountSecurity': {
    'ChangePassword': 'tukar kata laluan',
    'ChangePasswordDesc': 'Jika terlupa kata laluan kerana anda sudah lama tidak log masuk, anda boleh menukar kata laluan selepas pengesahan identiti.',
    'BindingPhone': 'Ikat dengan telefon',
    'BindingPhoneDesc': 'Nombor mudah alih terikat boleh digunakan untuk log masuk, mendapatkan kata laluan, penempatan pesanan dan perkhidmatan lain.',
    'BindingEmail': 'Ikat dengan e-mel',
    'BindingEmailDesc': 'E-mel terikat boleh digunakan untuk log masuk, mendapatkan kata laluan, penempatan pesanan dan perkhidmatan lain.',
    'SettingName': 'Tetapkan Nama Pengguna',
    'SettingNameDesc': 'Nama Pengguna boleh digunakan sebagai akaun log masuk dan tidak boleh ditukar',
    'firstname': 'first name',
    'lastname': 'last name',
    'SettingRealName': 'Set First name&Last name	',
    'SettingRealNameDesc': 'Set personal name information as an account attribute that can be edited multiple times.',
    'immediatelySet': 'Sediakan sekarang',
    'alreadySet': 'Telah ditetapkan',
    'settingComplete': 'Persediaan selesai',
    'alreadyBinding': 'Terikat',
    'userName': 'Nama pengguna',
    'userNameLogin': 'Log masuk dengan nama pengguna',
    'selfCreate': 'Dijana secara automatik',
    'stopEdit': 'Nama Pengguna tidak boleh ditukar selepas persediaan',
    'setOk': 'Persediaan selesai',
    'cancelAccount': 'Batalkan akaun',
    'cancelAccountTips': 'Berhati-hati, data tidak boleh dipulihkan selepas pembatalan',
    'toCancel': 'Batal sekarang',
    'cancelToKnow': 'Perjanjian pembatalan akaun',
    'cancelDesc1': '1. Apabila anda meminta pembatalan, akaun yang telah dibatalkan tidak akan dapat digunakan atau dipulihkan. Sila berhati-hati dan sandar semua maklumat dan data berkaitan dengan akaun anda sebelum melanjutkan;',
    'cancelDesc2': '2. Memohon pembatalan bermakna anda secara sukarela melepaskan semua keistimewaan keahlian dan aset maya (termasuk tetapi tidak terhad kepada mata ganjaran keahlian, tahap keahlian dan keistimewaan, kupon dan sebagainya);',
    'cancelDesc3': '3. Selepas pembatalan, anda tidak boleh log masuk dan menggunakan akaun ini dan mencari sebarang kandungan atau maklumat yang berkaitan dengan akaun ini, termasuk tetapi tidak terhad kepada nama pengguna dan ikon (maklumat bil laluan akan disimpan berdasarkan had masa yang dipersetujui oleh dasar privasi , anda boleh menyemak maklumat laluan dengan No. bil laluan di laman web rasmi KEX);',
    'cancelDesc4': '4. Jika anda telah mengaktifkan akaun kad kredit, selepas pembatalan, hubungan mengikat akaun ini dan akaun kredit anda akan dibatalkan; jika anda perlu terus menggunakan akaun kredit, anda perlu mengikat dengan akaun baharu;',
    'cancelDesc5': '5. Pembatalan akaun ini tidak mengetepikan atau mengurangkan liabiliti berkaitan tingkah laku sebelum pembatalan akaun;',
    'cancelDesc6': '6. Permohonan pembatalan ini boleh dibatalkan dalam masa 15 hari, pengguna boleh membatalkan permohonan pembatalan akaun dalam tempoh 15 hari selepas pembatalan.',
    'cancelAgree': 'Saya telah baca dan setuju dengan "Perjanjian Pembatalan Akaun"',
    'cancelTitle': 'Batalkan akaun',
    'cancelConfirm': 'Sahkan untuk membatalkan akaun sekarang?',

    'cancelTips': 'Akaun anda tidak terikat dengan nombor telefon mudah alih atau e-mel. Sila pergi untuk mengikat dahulu.',
    'goBinding': 'Ikat sekarang',
    'changeBinding': 'Tukar ikatan dengan segera',
    'auth': 'Pengesahan identiti',
    'finish': 'Pengubahsuaian selesai',
    'binding': 'Ikat segera>',
    'verifyType': 'Sila pilih mod pengesahan',
    'ChangePhone': 'Ubah telefon no.',
    'ChangeEmail': 'Ubah e-mel',
    'tips1': 'Tahniah, kata laluan anda telah berjaya ditukar',
    'tips2': 'Tahniah, nombor telefon anda telah berjaya ditukar.',
    'tips3': 'Tahniah, e-mel anda telah berjaya ditukar.',
    'tips4': 'Tahniah, nombor telefon anda telah berjaya diikat',
    'tips5': 'Tahniah, e-mel anda telah berjaya diikat.',
    'tips6': 'Tahniah, nama pengguna anda berjaya ditetapkan',
    pleaseFirst: 'Sila',
    or: 'atau',
    'end': 'dahulu'
  },
  'accountConflict': {
    'title': 'Pengesahan maklumat akaun',
    'desc1': 'Pelanggan yang dikasihi,',
    'desc2': 'Sistem telah mengesan bahawa E-mel/telefon bimbit anda telah didaftarkan dalam berbilang sistem syarikat kami. </br>Untuk menambah baik pengalaman anda, sila pilih salah satu akaun log masuk anda sebagai akaun log masuk bersatu bagi berbilang sistem.',
    'desc3': 'Selepas mengklik "Sahkan", sistem akan menghantar E-mel atau SMS kepada anda untuk menetapkan semula kata laluan anda. Sila ikut arahan dan simpan dengan betul.',
    'loginName': 'Nama log masuk',
    'phone': 'nombor telefon bimbit',
    'registerSys': 'Sistem pendaftaran',
    'registerTime': 'Masa pendaftaran',
    'newRegister': 'Pendaftaran baru',
    'infoVer': 'Sahkan maklumat',
    'inforVerSelect': 'Sila pilih kaedah pengesahan anda',
    'selectOne': 'Sila pilih salah satu akaun log masuk anda',
    'IBS': 'Sistem Pengurusan Pesanan dan Penghantaran',
    'ICAS': 'Sistem Akaun Pelanggan Antarabangsa',
    'IUOP': 'Platform Pesanan Bersatu Antarabangsa',
    'IBSE': 'Eksport Sistem Perniagaan Antarabangsa',
    'PMS': 'Import Sistem Perniagaan Antarabangsa',
    'IBSI': 'Import Sistem Perniagaan Antarabangsa',
    'SFBUY': 'SFBUY',
    'POP': 'Platform Terbuka Rakan Kongsi',
    'SFGOAPP': 'SF GO',
    'IFTP': 'Platform Pengangkutan Kargo Antarabangsa',
    'OFTP': 'Platform Pengangkutan Kargo Luar Negara',
  },
  permission: {
    'reset': 'Tetapkan semula',
    'enable': 'membenarkan',
    'disable': 'Lumpuhkan',
    'delete': 'Padamkan',
    'deleteBatch': 'Padam mengikut kelompok',
    'remark': 'Kenyataan',
    'sort': 'Menyusun',
    'confirm': 'sahkan',
    'cancel': 'batalkan',
    'operation': 'Beroperasi',
    'modify': 'ubah suai',
    'select': 'Sila pilih',
    'input': 'Sila masukkan ID Pengguna atau Nama Pengguna',
    'query': 'Pertanyaan',
    'edit': 'edit',
    'required_rule': 'Data tidak boleh kosong',
    'success': 'Operasi berjaya',
    'fail': 'Operasi gagal',
    'length_rule': 'Panjangnya ialah dari {min} hingga {maks} karakter',
    'deleteTip1': 'Sila lumpuhkan semua subsistem di bawah "{name}" dahulu',
    'deleteTis': 'Adakah anda pasti akan memadamkan item data dengan nama "{name}"?',
    'deleteChildTis': 'Semua sistem di bawah sistem akan dipadamkan pada masa yang sama',
    'tis': 'petunjuk',
    'deleteBatchTis': 'Adakah anda pasti akan memadamkan {num} keping data yang dipilih?',
    'enableTis': 'Adakah anda pasti mendayakan/melumpuhkan {num} kepingan data yang dipilih dengan nama{statusName}?',
    'msgError': 'Operasi yang salah',
    'codeCheckRule': 'Huruf besar dan kecil, nombor, "_"atau"-"',
    'checkMinCharacter': 'Sila masukkan lebih daripada {min} karakter',
    'roleType_0': 'Peranan yang ditubuhkan sendiri',
    'roleType_1': 'Pentadbir sistem',
    'bindResource': 'Ikat dengan sumber',
    'roleList': 'Senarai peranan',
    'roleAdd': 'Tambah peranan',
    'roleEdit': 'Edit peranan',
    'roleConfig': 'Konfigurasikan peranan',
    'childSystemName': 'Nama subsistem',
    'roleNo': 'Nombor peranan.',
    'roleName': 'Nama peranan',
    'roleDescribe': 'Penerangan peranan',
    'isSystem': 'Sistem subordinat',
    'roleType': 'Jenis peranan',
    'userStatus_0': 'Tidak diaktifkan',
    'userStatus_1': 'Diaktifkan',
    'userStatus_2': 'Pra-dibatalkan',
    'userStatus_3': 'dibatalkan',
    'userStatus_4': 'Dilumpuhkan',
    'userStatus_5': 'penguncian',
    'userRoleEdit': 'Lihat/edit peranan',
    'userList': 'Senarai pengguna',
    'regtime': 'Masa pendaftaran',
    'userCode': 'ID Pengguna',
    'area': 'Kawasan',
    'nickName': 'Nama panggilan',
    'sourceSystem': 'Sistem sumber',
    'userStatus': 'Status',
    'systemList': 'Senarai sistem',
    'systemAdd': 'Tambah sistem',
    'systemModify': 'Ubah suai sistem',
    'systemName': 'Nama sistem',
    'systemType': 'Jenis sistem',
    'systemType_0': 'data utama',
    'systemType_1': 'Sistem perniagaan',
    'systemCode': 'Kod sistem',
    'systemStatus': 'Status sistem',
    'systemStatus_0': 'membenarkan',
    'systemStatus_1': 'Dilumpuhkan',
    'systemAddChildren': 'Tambah sub-sistem',
    'systemSuperior': 'Sistem unggul',
    'resourceList': 'Senarai sumber',
    'resourceAdd': 'Tambah sumber',
    'resourceModify': 'Semak semula sumber',
    'resourceName': 'Nama sumber',
    'resourceType': 'Jenis sumber',
    'resourceType_MENU': 'Menu',
    'resourceType_MODULE': 'Kandungan',
    'resourceType_WIDGET': 'Butang',
    'resourceCode': 'Kod sumber',
    'resourceStatus': 'Status sumber',
    'resourceStatus_true': 'membenarkan',
    'resourceStatus_false': 'Dilumpuhkan',
    'resourceAddChildren': 'Tambah sub-item',
    'resourceSuperior': 'Menu unggul',
    'icon': 'Gaya ikon',
    'iconActive': 'Ikon aktif',
    'shortName': 'Nama pendek',
    'resourceUrl': 'URL sumber',
    'resourceFun': 'URL fungsi',
    'openType': 'Mod membuka',
    'openType_0': 'Laluan halaman',
    'openType_1': 'Tingkap baharu',
    'pub': 'Adakah kawalan kebenaran diperlukan',
    'pub_true': 'Ya',
    'pub_false': 'Tidak',
    'hidden': 'Sembunyi atau tidak',
    'hidden_0': 'Ya',
    'hidden_1': 'Tidak',
    'selectSystem': 'Sila pilih sistem'
  },
  protocol: {
    'num': 'Nombor',
    'protocolName': 'Nama perjanjian',
    'protocolNo': 'Nombor versi protokol',
    'signTime': 'Masa menandatangani',
    'remark': 'Kenyataan',
    'signUser': 'Nombor akaun yang ditandatangani',
    'signName': 'Nama pelanggan yang ditandatangani',
    'signChild': 'Nombor subversi protokol'
  },
  sfbuy: {
    'wechatScane': 'Imbas dengan WeChat',
    'wechatScane1': 'masa sebenar',
    'wechatScane2': 'pengesanan bungkusan',
    'onlineService': 'Perkhidmatan dalam talian',
    'aboutUs': 'Mengenai kami',
    'serviceGuide': 'Panduan perkhidmatan',
    'helpCenter': 'Pusat bantuan',
    'serviceAndPrice': 'Perkhidmatan dan Harga',
    'announcement': 'Pengumuman',
    'important': 'penting'
  },
  messageNotice: {
    'yxDetail': 'butiran',
    'optional': 'pilihan',
    'loginXyAgree': 'Saya bersetuju untuk menerima pemberitahuan pemasaran dan pengiklanan',
    messageNotice: 'Pemberitahuan Mesej',
    messageNoticeDesc: 'Sokong pengubahsuaian pemberitahuan',
    messageNoticeBtn: 'Ubah konfigurasi',
    messageNoticeTitle: 'Konfigurasi Pemberitahuan Pemasaran',
    messageNoticeTitleDesc1: 'Rujuk ',
    messageNoticeTitleDesc2: ' pengumpulan maklumat peribadi. Centang bermaksud bersetuju menerima pemasaran dan iklan',
    messageNoticeDetailTitle: 'Butiran Data Pemberitahuan Pemasaran',
    message: 'SMS',
    messageNotcieDialogTitle: 'Konfigurasi Saluran Pemasaran',
    considerLater: 'Akan pertimbangkan kemudian',
    messageNotcieDialogDesc1:
    'Mengklik butang pengesahan bermakna anda bersetuju kami menggunakan saluran berikut untuk menghantar pemasaran dan iklan yang mungkin anda minati. Lihat ​',
    messageNotcieDialogDesc2: ' mengenai pengumpulan maklumat peribadi.',
    messageNotcieDialogDetail: 'butiran',
  },
  weakPassword: {
    提示: 'Petua',
    账号异常提醒: 'Akaun anda ada aktiviti mencurigakan. Sila tukar kata laluan atau log masuk dengan kod pengesahan/imbas kod QR.',
    修改密码: 'Tukar Kata Laluan',
    关闭: 'Tutup',
    账号异常处理: 'Pengurusan Akaun Tidak Normal',
    绑定提示: 'Sila daftar telefon atau emel terlebih dahulu, kemudian ubah kata laluan',
    账号: 'Akaun'
  },
  recommendedPassword: {
    使用推荐密码: 'Gunakan kata laluan yang disyorkan',
    提示: 'Nota',
    请保管好您的密码:
      'Sila simpan kata laluan anda dengan baik. Kami mengesyorkan anda menukarnya secepat mungkin selepas log masuk.',
    复制密码: 'Salin Kata Laluan',
    psd: 'Kata Laluan',
    copySuccess: 'Salin berjaya',
    注册成功: 'Tahniah kerana berjaya mendaftar!',
    注册建议: 'Untuk keselamatan akaun, disyorkan anda pergi ke "Pusat Pengurusan - Tetapan Akaun" untuk menukar kata laluan.',
    修改密码: ''
  },
  twoFactorAuth: {
    双因素认证: 'pengesahan dua faktor',
    认证方式: 'Kaedah pengesahan',
    为了您的账号安全: 'Untuk keselamatan akaun anda, sila lengkapkan pengesahan dua faktor sebelum log masuk.',
    请选择绑定: 'Sila pilih untuk mengikat.:',
    请先设置您的密码: 'Sila tetapkan kata laluan anda dahulu'
  },

  sendType: {
    您当前手机区号不支持whatsapp: 'Kod kawasan telefon semasa anda tidak menyokong {noticeChanel}, sila pilih kaedah lain untuk mendapatkan kod pengesahan',
    请使用绑定手机号接收验证码: 'Sila gunakan nombor telefon yang didaftarkan untuk menerima kod pengesahan',
    请使用绑定邮箱接收验证码: 'Sila gunakan e-mel yang didaftarkan untuk menerima kod pengesahan',
    请选择验证码接收方式: 'Sila pilih kaedah menerima kod pengesahan'
  },
  recommendFloat: {
    '满意度评价': 'Penilaian Kepuasan',
    '您的评价对我们很重要': 'Maklum balas anda sangat penting bagi kami',
    '我要评价': 'Saya ingin menilai'
  }
}
